import { render } from "./Agents.vue?vue&type=template&id=4a2ed98e&scoped=true"
import script from "./Agents.vue?vue&type=script&lang=js"
export * from "./Agents.vue?vue&type=script&lang=js"

import "./custom-agents.scss?vue&type=style&index=0&id=4a2ed98e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a2ed98e"]])

export default __exports__